import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { isTeamCallInReasonsRequested, TEAM_CALL_IN_REASONS_PARAM } from "./deepLink";

/**
 * DAT-850 · Applies `?call_in_reasons=true` (the Hiring page's absence panel) once: opens the Call-in reasons tab
 * through `openCallInReasonsTab`, then strips the param so Back does not re-select it over the user's own choice.
 * `openCallInReasonsTab` must be stable (it is an effect dependency).
 *
 * A viewer who cannot see that tab lands on Team through the page's own fallback.
 */
export const useCallInReasonsDeepLink = (openCallInReasonsTab: () => void) => {
	const [searchParams, setSearchParams] = useSearchParams();
	useEffect(() => {
		if (!isTeamCallInReasonsRequested(searchParams)) return;
		openCallInReasonsTab();
		// Updater form, not the snapshot: the Team filters write the same query string in the same tick.
		setSearchParams(
			(current) => {
				const remaining = new URLSearchParams(current);
				remaining.delete(TEAM_CALL_IN_REASONS_PARAM);
				return remaining;
			},
			{ replace: true },
		);
	}, [searchParams, setSearchParams, openCallInReasonsTab]);
};
